import { useInlineNotifications } from '../../../../../hooks'
import { useCloseConfirm } from '../../../../Form'
import { FormikForm } from '../../../../Formik'
import { WidgetFormContainer } from '../../../../Widget'
import { getRequestProfileWidgetProvidersPayload } from '../RequestProfileWidgetProviders.utils'

import { getRequestProfileWidgetProvidersFormValidationSchema } from './RequestProfileWidgetProvidersForm.utils'
import { RequestProfileWidgetProvidersFormFields } from './RequestProfileWidgetProvidersFormFields'

function RequestProfileWidgetProvidersForm({
  initialRecommendedProviderId,
  initialValues,
  modal,
  recommendationTooltipKey,
  recommendedProviders,
  requestId,
  requestPermissions,
  onClose,
  onSubmit,
  onSuccess,
}) {
  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema =
    getRequestProfileWidgetProvidersFormValidationSchema(initialValues)

  async function handleSubmit(values, formikHelpers) {
    return onSubmit({
      payload: getRequestProfileWidgetProvidersPayload(values),
    })
      .then(() => {
        onSuccess?.()
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        isCloseConfirm,
        modal,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <RequestProfileWidgetProvidersFormFields
        initialRecommendedProviderId={initialRecommendedProviderId}
        notifications={notifications}
        recommendationTooltipKey={recommendationTooltipKey}
        recommendedProviders={recommendedProviders}
        requestId={requestId}
        requestPermissions={requestPermissions}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RequestProfileWidgetProvidersForm
